import { isValidObject, LILAC_300, PRIMARY_BOLD_FONT, tokens, typographyConfig } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getPaymentDetailsWidgetStyles = props => {
  var keyPairData = props.keyPairData;
  var shouldAddBottomSpace = !isValidObject(keyPairData);
  var spacingToken = tokens.spacing;
  var fontConfig = typographyConfig[props === null || props === void 0 ? void 0 : props.theme];
  return StyleSheet.create({
    gridStyle: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginLeft: spacingToken.SPACING_64 - spacingToken.SPACING_6,
      marginRight: spacingToken.SPACING_10
    },
    dividerStyle: {
      paddingHorizontal: spacingToken.SPACING_16,
      marginVertical: spacingToken.SPACING_8
    },
    inputContainerStyle: {
      flexDirection: 'row',
      alignItems: 'center',
      marginLeft: spacingToken.SPACING_64,
      marginRight: spacingToken.SPACING_10
    },
    hintMsgStyle: {
      paddingTop: spacingToken.SPACING_4,
      paddingRight: spacingToken.SPACING_4,
      marginBottom: spacingToken.SPACING_6,
      marginLeft: spacingToken.SPACING_64
    },
    textInputStyle: Object.assign(Object.assign({}, fontConfig.config.types['h3-bold'].typographyStyles), {
      fontFamily: PRIMARY_BOLD_FONT,
      flex: 1
    }),
    containerStyle: Object.assign({
      justifyContent: 'flex-start',
      paddingTop: spacingToken.SPACING_16
    }, shouldAddBottomSpace && {
      paddingBottom: spacingToken.SPACING_16
    }),
    gridItemStyle: {
      margin: spacingToken.SPACING_6
    },
    calloutStyle: {
      paddingTop: spacingToken.SPACING_16,
      paddingHorizontal: spacingToken.SPACING_20
    },
    keyPairContainerStyle: {
      backgroundColor: LILAC_300,
      paddingVertical: spacingToken.SPACING_8,
      paddingHorizontal: spacingToken.SPACING_16,
      borderBottomLeftRadius: spacingToken.SPACING_16,
      borderBottomRightRadius: spacingToken.SPACING_16,
      marginTop: spacingToken.SPACING_12
    }
  });
};